import styles from './MatchResultMobile.module.css';
import { formatDateTime } from 'helpers/dateHelper';
import { buildResultsRowDisplay } from 'helpers/resultsDisplayHelper';
import { MatchOffer } from 'types/MatchOffer';
import { useTranslation } from 'react-i18next';

type Props = {
  match: MatchOffer;
  sportId: number;
};

export function MatchResultMobile({ match, sportId }: Props) {
  const { t } = useTranslation();
  const kick = new Date(match.time * 1000);
  const cols = buildResultsRowDisplay(match, sportId);
  const homeName = match.home?.name ?? '';
  const awayName = match.away?.name ?? '';

  return (
    <article className={styles.card}>
      <div className={styles.top}>
        <time className={styles.time}>
          {formatDateTime(kick, { removeDate: true, removeSeconds: true })}
        </time>
        <div className={styles.teams}>
          <span>{homeName}</span>
          <span>{awayName}</span>
        </div>
      </div>
      <div className={styles.scores}>
        <div className={styles.scoreCell}>
          <span className={styles.scoreLabel}>{t('results_col_ft')}</span>
          <span className={styles.ft}>{cols.ft}</span>
        </div>
        <div className={styles.scoreCell}>
          <span className={styles.scoreLabel}>{t('results_col_ht')}</span>
          <span>{cols.ht}</span>
        </div>
        <div className={styles.scoreCell}>
          <span className={styles.scoreLabel}>{t('results_col_ot')}</span>
          <span>{cols.ot}</span>
        </div>
        <div className={styles.scoreCell}>
          <span className={styles.scoreLabel}>{t('results_col_tip')}</span>
          <span>{cols.tip}</span>
        </div>
        <div className={styles.scoreCell}>
          <span className={styles.scoreLabel}>{t('results_col_odd')}</span>
          <span>{cols.odd}</span>
        </div>
      </div>
    </article>
  );
}
